import React, { Component } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import ProgressiveImage from 'react-progressive-image';
import './HeaderCarousel.scss';

class HeaderCarousel extends Component {
  render() {
    const controls = {
      emulateTouch: true,
      autoPlay: true,
      showArrows: false,
      swipeable: true,
      loop: true,
      interval: 3000,
      showIndicators: false,
      showStatus: false,
      showThumbs: false,
      infiniteLoop: true,
      transitionTime: 500
    };

    let slides = this.props.headSliderSources.map(slide => {
      return (
        <div className="slide-container" key={slide.id}>
          <div className="gradient-lazy-load">
            <ProgressiveImage src={slide.imgSrc} placeholder={slide.lazyImg}>
              {(src, loading) => (
                <img
                  style={{
                    opacity: loading ? 0.5 : 1,
                    filter: loading ? 'blur(5px)' : '',
                    transition: 'opacity 1s ease'
                  }}
                  src={src}
                  alt={slide.title}
                />
              )}
            </ProgressiveImage>
          </div>

          <div className="slide-description">
            <p className="slide-description__trending">Trending</p>
            <h2 className="slide-description__title">{slide.title}</h2>
            <p className="slide-description__rating">rating: {slide.rating}</p>
          </div>
        </div>
      );
    });

    return (
      <div className="carousel-container">
        <Carousel className="presentation-mode" {...controls}>
          {slides}
        </Carousel>
      </div>
    );
  }
}

export default HeaderCarousel;
